export const milestones = [
  { year: '2015', title: '扬帆起航', description: '征途国际在北京正式成立，创始团队汇聚国际化领域的资深专家，确立"助力中国企业走向世界"的核心使命。' },
  { year: '2016', title: '初露锋芒', description: '完成首批10家企业的国际化咨询服务，服务范围覆盖东南亚和中东地区，客户满意度达100%。' },
  { year: '2018', title: '布局全球', description: '在新加坡、迪拜、伦敦设立海外分支机构，服务网络拓展至全球20多个国家和地区。' },
  { year: '2020', title: '数字转型', description: '推出数字化服务平台，整合全球商业数据库和智能匹配系统，实现线上线下协同服务模式。' },
  { year: '2022', title: '战略升级', description: '服务企业累计突破300家，年服务营收突破5亿元，成为行业领先的国际化服务品牌。' },
  { year: '2024', title: '生态共建', description: '联合全球50+战略合作伙伴，构建国际化服务生态圈，为客户提供更加全面和深度的全球服务。' },
  { year: '2025', title: '全新征程', description: '服务企业累计突破500家，持续创新服务模式，以更专业的姿态助力中国企业征战全球。' },
];

export const testimonials = [
  {
    name: '王志远',
    title: '华远科技集团 CEO',
    content: '征途国际的团队对东南亚市场有着深刻的理解和丰富的资源。在他们的帮助下，我们仅用半年时间就完成了在三个国家的市场布局，效率远超预期。',
    avatarQuery: 'Asian male CEO professional portrait in suit warm lighting executive headshot',
  },
  {
    name: '李明月',
    title: '瑞丰新能源 国际部总监',
    content: '从市场调研到合作伙伴对接，征途国际展现了极高的专业水准。特别是在跨境谈判中，他们的本地化团队发挥了关键作用。',
    avatarQuery: 'Asian female business executive professional portrait confident warm lighting corporate headshot',
  },
  {
    name: '陈大卫',
    title: '雅生活消费品 创始人',
    content: '品牌国际化是我们最头疼的问题，征途国际帮我们重新定义了品牌策略，现在的品牌形象在国际市场上得到了广泛认可。',
    avatarQuery: 'Asian male entrepreneur professional portrait in casual blazer warm lighting modern headshot',
  },
];

export const team = [
  {
    name: '张明远',
    title: '创始人 & CEO',
    description: '前麦肯锡全球合伙人，20年国际化战略咨询经验，曾服务超过100家Fortune 500企业。',
    avatarQuery: 'Senior Asian male executive professional portrait in tailored suit confident expression warm corporate headshot',
  },
  {
    name: '李婉清',
    title: '联合创始人 & COO',
    description: '前阿里巴巴国际站高管，15年跨境电商和国际化运营经验，精通东南亚和中东市场。',
    avatarQuery: 'Professional Asian female executive portrait in modern business attire elegant confident warm lighting headshot',
  },
  {
    name: 'James Chen',
    title: '国际业务副总裁',
    description: '前汇丰银行亚太区高管，18年国际金融和跨境投资经验，擅长跨国合作和资源整合。',
    avatarQuery: 'Asian male executive in international business setting professional portrait confident expression warm corporate headshot',
  },
  {
    name: '赵安琪',
    title: '品牌战略总监',
    description: '前奥美中国品牌策略总监，12年国际品牌建设和传播经验，主导过50+国际品牌项目。',
    avatarQuery: 'Asian female creative director professional portrait artistic yet corporate warm lighting modern headshot',
  },
];